import type { RouteRecordRaw } from 'vue-router'

const routes: RouteRecordRaw[] = [
  {
    path: '/plugins',
    component: () => import('@/components/layout/AppLayout.vue'),
    children: [
      {
        path: '',
        name: 'marketplace',
        component: () => import('@/views/plugins/PluginListView.vue'),
      },
      {
        path: ':id',
        name: 'marketplace-plugin',
        component: () => import('@/views/plugins/PluginDetailView.vue'),
      },
    ],
  },
  {
    path: '/publish',
    component: () => import('@/components/layout/AppLayout.vue'),
    children: [
      {
        path: '',
        name: 'publish',
        component: () => import('@/views/plugins/PublishRulesView.vue'),
      },
    ],
  },
  {
    path: '/auth',
    component: () => import('@/components/layout/AuthLayout.vue'),
    children: [
      {
        path: 'login',
        name: 'login',
        component: () => import('@/views/auth/LoginView.vue'),
        meta: { guestOnly: true },
      },
      {
        path: 'register',
        name: 'register',
        component: () => import('@/views/auth/RegisterView.vue'),
        meta: { guestOnly: true },
      },
      {
        path: 'forgot-password',
        name: 'forgot-password',
        component: () => import('@/views/auth/ForgotPasswordView.vue'),
        meta: { guestOnly: true },
      },
      {
        path: 'reset-password',
        name: 'reset-password',
        component: () => import('@/views/auth/ResetPasswordView.vue'),
      },
      {
        path: 'verify-email',
        name: 'verify-email',
        component: () => import('@/views/auth/VerifyEmailView.vue'),
      },
      {
        path: 'oauth/:provider/callback',
        name: 'oauth-callback',
        component: () => import('@/views/auth/OAuthCallbackView.vue'),
      },
    ],
  },
  {
    path: '/',
    component: () => import('@/components/layout/AppLayout.vue'),
    meta: { requiresAuth: true },
    children: [
      {
        path: '',
        redirect: { name: 'developer-dashboard' },
      },
      {
        path: 'developer',
        meta: { role: 'developer' },
        children: [
          {
            path: '',
            name: 'developer-dashboard',
            component: () => import('@/views/developer/DashboardView.vue'),
          },
          {
            path: 'plugins',
            name: 'developer-plugins',
            component: () => import('@/views/developer/PluginListView.vue'),
          },
          {
            path: 'plugins/new',
            name: 'developer-plugin-create',
            component: () => import('@/views/developer/PluginCreateView.vue'),
          },
          {
            path: 'plugins/:id',
            name: 'developer-plugin-detail',
            component: () => import('@/views/developer/PluginDetailView.vue'),
          },
          {
            path: 'plugins/:id/edit',
            name: 'developer-plugin-edit',
            component: () => import('@/views/developer/PluginEditView.vue'),
          },
          {
            path: 'plugins/:id/versions/new',
            name: 'developer-version-create',
            component: () => import('@/views/developer/VersionCreateView.vue'),
          },
          {
            path: 'plugins/:id/versions/:versionId/edit',
            name: 'developer-version-edit',
            component: () => import('@/views/developer/VersionEditView.vue'),
          },
          {
            path: 'support',
            name: 'developer-support',
            component: () => import('@/views/developer/SupportView.vue'),
          },
        ],
      },
      {
        path: 'admin',
        meta: { role: 'admin' },
        children: [
          {
            path: '',
            name: 'admin-dashboard',
            component: () => import('@/views/admin/DashboardView.vue'),
          },
          {
            path: 'plugins',
            name: 'admin-plugins',
            component: () => import('@/views/admin/PluginListView.vue'),
          },
          {
            path: 'plugins/:id',
            name: 'admin-plugin-detail',
            component: () => import('@/views/admin/PluginDetailView.vue'),
          },
          {
            path: 'plugins/:id/edit',
            name: 'admin-plugin-edit',
            component: () => import('@/views/admin/PluginEditView.vue'),
          },
          {
            path: 'pending',
            name: 'admin-pending',
            component: () => import('@/views/admin/PendingQueueView.vue'),
          },
          {
            path: 'categories',
            name: 'admin-categories',
            component: () => import('@/views/admin/CategoryListView.vue'),
          },
          {
            path: 'labels',
            name: 'admin-labels',
            component: () => import('@/views/admin/LabelListView.vue'),
          },
          {
            path: 'languages',
            name: 'admin-languages',
            component: () => import('@/views/admin/LanguageListView.vue'),
          },
          {
            path: 'users',
            name: 'admin-users',
            component: () => import('@/views/admin/UserListView.vue'),
          },
          {
            path: 'subscriptions',
            name: 'admin-subscriptions',
            component: () => import('@/views/admin/SubscriptionListView.vue'),
          },
        ],
      },
      {
        path: 'profile',
        name: 'profile',
        component: () => import('@/views/profile/ProfileView.vue'),
      },
      {
        path: 'profile/password',
        name: 'change-password',
        component: () => import('@/views/profile/ChangePasswordView.vue'),
      },
      {
        path: 'support',
        name: 'support',
        component: () => import('@/views/developer/SupportView.vue'),
      },
    ],
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'not-found',
    component: () => import('@/views/NotFoundView.vue'),
  },
]

export default routes
